import React, { useState, useEffect } from "react";
import { SidePopup } from "../../../components/model-popup/side-popup";
import { CustomButton } from "../../../components/buttons/button";
import TextIconInput from "../../../components/custom-fields/input";
import Table from "../../../components/table/table";

import SearchIcon from "../../../assets/icons/search-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearchPatientList } from "../../../redux/slices/patientlookup.slice";


import moment from "moment";
import { WordTitle } from "../../../utils/commonFunction";
import { toast } from "react-toastify";
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { UpdateNotesSourceDetailsAPI } from "../../../api/update";

import { useFormik } from "formik";
import ErrorMessage from "../../../components/custom-fields/error-message";
import * as yup from "yup";
import { alphabetValidate } from "../../../utils/field-validation";
import SelectInput from "../../../components/custom-fields/select";
import NotesDocs from "../notes_docs";

export const NoteDetailsUpdatePopup = (props: any) => {
    const dispatch: any = useDispatch();
    const {
        showModal,
        setShowModal,
        handleClose,
        poupDetails,
        afterChangeNotesList,
        facList
    } = props;


    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [showSearchPatientName, setShowSearchPatientName] = useState<string | null>(null);
    const [searchPatientName, setSearchPatientName] = useState<string | null>(null);
    const [searchedDate, setSearchedDate] = useState<string | null>(null);
    const searchPatientList = useSelector(
        (state: any) => state.patientlookUp?.searchPatientList || []
    );

    // const [mappedPatientDetails, setMappedPatientDetails] = useState<any>({})

    // table
    const [loader, setLoader] = useState<boolean>(true);
    const [page, setPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [sort, setSort] = useState<string>("lastName");
    const [sortDir, setSortDir] = useState<string>("asc");
    const [limit,] = useState<number>(15);

    // confirm model
    const [showConfirmModel, setShowConfirmModel] = useState<boolean>(false);

    const ConvertDate = (date_string: string) => {
        const isValidFormat: boolean = moment(date_string, "YYYY-MM-DD", true).isValid();
        const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["MM/DD/YYYY", "DD/MM/YYYY"]).format("YYYY-MM-DD");
        return formattedDate
    };

    const ConvertOutputDate = (date_string: string, outputFormat = "YYYY-MM-DD") => {
        const isValidFormat = moment(date_string, "YYYY-MM-DD", true).isValid();
        const parsedDate = isValidFormat
            ? moment(date_string, "YYYY-MM-DD", true)
            : moment(date_string, ["YYYY-MM-DD", "DD/MM/YYYY"]);

        return parsedDate.isValid() ? parsedDate.format(outputFormat) : "";
    };

    const [, setTotalRecord] = useState<number>(0);

    const [facilityList, setFacilityList] = useState(facList)
    const [selectLocation, setSelectLocation] = useState<string>('');

    const handleSearch = (term: string) => {
        const filteredFacilities = facList.filter((facility: any) =>
            facility.facilityName?.toLowerCase().includes(term?.toLowerCase())
        );
        if (filteredFacilities.length === 0) {
            setFacilityList([...facList, { facilityName: term, id: '' }])
            return term;
        } else {
            return filteredFacilities[0].facilityName
        }
    };

    useEffect(() => {
        if (poupDetails?.location) {
            const location = handleSearch(poupDetails.location);
            setSelectLocation(location);
        }
    }, [poupDetails?.location, facList, showModal]);

    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            patient_first_name: poupDetails?.patient_first_name || "",
            patient_last_name: poupDetails?.patient_last_name || "",
            location: selectLocation,
            DOB: poupDetails?.DOB ? ConvertDate(poupDetails?.DOB) : "",
            encounter_date: poupDetails?.encounter_date ? ConvertDate(poupDetails?.encounter_date) : "",
            gender: poupDetails?.gender?.toLowerCase() || ''
        },

        validationSchema: yup.object({
            patient_first_name: yup.string().required("First Name is required"),
            patient_last_name: yup.string().required("Last Name is required"),
            gender: yup.string().required("Gender is required"),
            location: yup.string().required("location is required"),
            DOB: yup.string().required("DOB is required"),
            encounter_date: yup.string().required("Date of Service is required"),
        }),
        onSubmit: async (values: any) => {
            setShowConfirmModel(false);
            setButtonLoader(true);
            const formattedDOB = ConvertOutputDate(values.DOB);
            const formattedEncounterDate = ConvertOutputDate(values.encounter_date);
            const data = {
                first_name: values.patient_first_name,
                last_name: values.patient_last_name,
                location: values.location,
                gender: values.gender,
                dob: formattedDOB,
                encounter_date: formattedEncounterDate,
            }
            const handleUploadAPI = async () => {
                await UpdateNotesSourceDetailsAPI(poupDetails?.id, data)
                    .then(async (res: any) => {

                        if (res?.result) {
                            toast.success(res?.result?.message || "Notes details updated successfully");
                            setShowModal(false);
                            formik?.resetForm();
                            afterChangeNotesList()
                        } else {
                            if (res?.message)
                                toast.error(res?.message || "Notes details updated failed");
                        }
                    })
                    .catch((err: any) => {
                        console.error(err);
                    });

                setButtonLoader(false);
            };
            await handleUploadAPI()
        },
    });

    const handlePatientListData = (param: any = {}) => {
        const apiParam: any = {
            page: page,
            name: searchPatientName || '',
            sort: sort,
            sort_dir: sortDir,
            limit: limit,
            DOB: searchedDate || ''
        }
        if ('page' in param) {
            setPage(param?.page);
            apiParam['page'] = param['page']
        }
        if ('sort' in param) {
            apiParam['sort'] = param['sort'];
            apiParam['sort_dir'] = param['sortDir'];
            apiParam['page'] = 1
            setSort(param['sort'])
            setSortDir(param['sortDir'])
            setPage(1)
        }
        if ('DOB' in param) {
            setSearchedDate(param['DOB']);
            apiParam['DOB'] = param['DOB'] || '';
            apiParam['page'] = 1
            setPage(1)
        }
        if ('search' in param) {
            setSearchPatientName(param?.search);
            apiParam['name'] = param['search'] || '';
            apiParam['page'] = 1
            setPage(1)
        }


        if (apiParam['page'] === 1) {
            setLoader(true)
        }
        dispatch(
            fetchSearchPatientList(apiParam)
        ).then((res: any) => {
            setTotalPage(res?.payload?.total_pages);
            setTotalRecord(res?.payload?.total_count);
            setLoader(false);
        }).catch((error: any) => {
            console.error('[Patient Search] API Error:', error);
            setLoader(false);
        });
    }

    const handleNextPage = () => {
        handlePatientListData({ 'page': page + 1 });
    };

    const setSelectedPatient = (row: any) => {
        formik.setFieldValue('patient_first_name', row?.firstName, true);
        formik.setFieldValue('patient_last_name', row?.lastName, true);
        formik.setFieldValue('DOB', row?.birthDate ? ConvertDate(row?.birthDate) : '', true);
        formik.setFieldValue('gender', row?.gender ? row.gender.toLowerCase() : '', true);
    }

    const handleBirthDate = (value: string | null) => {
        if (value) {
            handlePatientListData({ 'DOB': value })
        } else {
            handlePatientListData({ 'DOB': null })
        }
    }

    const updatePatientDetailConfirm = async () => {
        const validateForm = await formik.validateForm()
        if (Object.keys(validateForm).length === 0) {
            setShowConfirmModel(true);  // Form is valid, show the confirmation modal
        } else {
            toast.error("Please fill all the required fields");  // Form is invalid
            Object.keys(validateForm).forEach((key) => {
                if (!formik.errors[key]) {
                    formik.setErrors(key, validateForm[key]);
                } else {
                    formik.setFieldTouched(key, true);
                }
            });
        }
    }


    const resetState = () => {
        setSearchedDate(null)
        setShowSearchPatientName(null)
        setSearchPatientName(null)
        setSort('lastName')
        setSortDir('asc')
    }



    useEffect(() => {
        if (showModal) {
            setFacilityList([...facList])
            const location = handleSearch(poupDetails.location);
            setSelectLocation(location);
            formik.setFieldValue('location', location ? location : '');
            handlePatientListData({ page: 1 })
            setShowConfirmModel(false)
            resetState()
        }
    }, [showModal])

    useEffect(() => {
        const handler = setTimeout(() => {
            handlePatientListData({ search: showSearchPatientName });
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [showSearchPatientName]);

    return (
        //eslint-disable-next-line
        //@ts-ignore

        <SidePopup
            showModal={showModal}
            handleClose={handleClose}
            width={"max-w-[1300px]"}
            title={'Update Notes Details'}
            closeIcon={false}
            bodyClass=" "
            footerStyle="flex justify-end gap-[16px] "
            footerContent={showConfirmModel ? null : (
                <>
                    <CustomButton
                        buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                        buttonName="Cancel"
                        primary={false}
                        disable={buttonLoader}
                        onClick={() => {
                            setShowModal(false);
                        }}
                    />
                    <CustomButton
                        type="submit"
                        loader={buttonLoader}
                        loaderStyle={`px-[40.5px] py-[13px] leading-[17px]`}
                        primary={true}
                        disable={buttonLoader}
                        buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]  "
                        buttonName={"Update"}
                        onClick={() => {
                            updatePatientDetailConfirm();
                        }}
                    />
                </>)
            }
        >
            <div
                className="pt-[1px] "

            >
                <div className={"w-full col-span-1 grid grid-cols-[33%_30%_auto] gap-2"}>

                    <NotesDocs id={poupDetails?.id} />

                    <div className="relative  border border-gray-200 rounded-lg shadow-sm h-[calc(100vh-180px)] overflow-y-auto scrollable-hidden">
                        <div className="font-normal text-gray-800 text-base bg-gray-200 py-2 px-4 rounded-t-lg sticky top-0 z-10 min-h-[2.8rem]">Notes Details</div>
                        <div className="text-[10px] p-2">
                            <div className="w-full col-span-1">
                                <TextIconInput
                                    label="Patient First Name"
                                    name="patient_first_name"
                                    id="patient_first_name"
                                    type="text"
                                    disable={buttonLoader}
                                    maxLength={30}
                                    value={formik.values.patient_first_name}
                                    onChange={formik.handleChange}
                                    onkeypress={alphabetValidate}
                                    errors={formik.errors.patient_first_name
                                        && formik.touched.patient_first_name}
                                    placeholder="Enter patient first name"
                                    onBlur={formik.handleBlur}
                                    required
                                />
                                {formik.errors.patient_first_name
                                    && formik.touched.patient_first_name
                                    ? (
                                        <ErrorMessage>
                                            {formik.errors.patient_first_name}
                                        </ErrorMessage>
                                    ) : (
                                        <span>&nbsp;</span>
                                    )}
                            </div>
                            <div className="w-full col-span-1">
                                <TextIconInput
                                    label="Patient Last Name"
                                    name="patient_last_name"
                                    id="patient_last_name"
                                    type="text"
                                    disable={buttonLoader}
                                    maxLength={30}
                                    value={formik.values.patient_last_name}
                                    onChange={formik.handleChange}
                                    onkeypress={alphabetValidate}
                                    errors={formik.errors.patient_last_name
                                        && formik.touched.patient_last_name}
                                    placeholder="Enter patient last name"
                                    onBlur={formik.handleBlur}
                                    required
                                />
                                {formik.errors.patient_last_name
                                    && formik.touched.patient_last_name ? (
                                    <ErrorMessage>
                                        {formik.errors.patient_last_name}
                                    </ErrorMessage>
                                ) : (
                                    <span>&nbsp;</span>
                                )}
                            </div>



                            <div className="w-full col-span-1">
                                <SelectInput
                                    divStyle="mt-[2px]"
                                    label={'Gender'}
                                    minLength={6}
                                    placeholder="Select Gender"
                                    maxLength={50}
                                    name="gender"
                                    id="gender"
                                    value={formik.values.gender}
                                    errors={formik.errors.gender && formik.touched.gender}
                                    onChange={formik.handleChange}
                                    disable={buttonLoader}
                                    onBlur={formik.handleBlur}
                                    options={[{ id: 'male', label: 'Male' }, { id: 'female', label: 'Female' }, { id: 'unknown', label: 'Unknown' }]}
                                    valueKey={'id'}
                                    labelKey={'label'}
                                    required
                                />
                                {formik.errors.gender && formik.touched.gender ? (
                                    <ErrorMessage>{formik.errors.gender}</ErrorMessage>
                                ) : (
                                    <span>&nbsp;</span>
                                )}
                            </div>
                            <div className="w-full col-span-1">
                                <TextIconInput
                                    divStyle="mt-[2px]"
                                    label={"DOB"}
                                    minLength={4}
                                    placeholder="Patient date of brith"
                                    maxLength={50}
                                    name="DOB"
                                    id="DOB"
                                    value={formik.values.DOB}
                                    errors={formik.errors.DOB && formik.touched.DOB}
                                    onChange={formik.handleChange}
                                    disable={buttonLoader}
                                    onBlur={formik.handleBlur}
                                    type={"date"}
                                    required
                                />

                                {formik.errors.DOB && formik.touched.DOB ? (
                                    <ErrorMessage>{formik.errors.DOB}</ErrorMessage>
                                ) : (
                                    <span>&nbsp;</span>
                                )}
                            </div>
                            <div className="w-full col-span-1">
                                <SelectInput
                                    divStyle="mt-[2px]"
                                    label={'Location'}
                                    minLength={6}
                                    placeholder="Select Location"
                                    maxLength={50}
                                    name="location"
                                    id="location"
                                    value={formik.values.location}
                                    errors={formik.errors.location && formik.touched.location}
                                    onChange={formik.handleChange}
                                    disable={buttonLoader}
                                    onBlur={formik.handleBlur}
                                    options={facilityList}
                                    valueKey={'facilityName'}
                                    labelKey={'facilityName'}
                                    required
                                />
                                {formik.errors.location && formik.touched.location ? (
                                    <ErrorMessage>{formik.errors.location}</ErrorMessage>
                                ) : (
                                    <span>&nbsp;</span>
                                )}
                            </div>
                            <div className="w-full col-span-1">
                                <TextIconInput
                                    divStyle="mt-[2px]"
                                    label={"Date of Service"}
                                    minLength={4}
                                    placeholder="Patient date of brith"
                                    maxLength={50}
                                    name="encounter_date"
                                    id="encounter_date"
                                    value={formik.values.encounter_date}
                                    errors={formik.errors.encounter_date
                                        && formik.touched.encounter_date}
                                    onChange={formik.handleChange}
                                    disable={buttonLoader}
                                    onBlur={formik.handleBlur}
                                    type={"date"}
                                    required
                                />

                                {formik.errors.encounter_date && formik.touched.encounter_date ? (
                                    <ErrorMessage>{formik.errors.encounter_date}</ErrorMessage>
                                ) : (
                                    <span>&nbsp;</span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="relative border border-gray-200 rounded-lg shadow-sm h-[calc(100vh-180px)] overflow-y-auto scrollable-hidden">
                        <div className="font-normal text-gray-800 text-base bg-gray-200 py-2 px-4 rounded-t-lg sticky top-0 z-10 min-h-[2.8rem]">Patient List</div>
                        <div className="p-2">
                            <div className="flex gap-2 mb-2">
                                <TextIconInput
                                    placeholder="Patient name"
                                    divStyle=""
                                    onChange={
                                        (e: any) => {
                                            if (setShowSearchPatientName) {
                                                setShowSearchPatientName(e.target.value);
                                            }
                                        }
                                    }
                                    inputStyle="w-full border-[#E8ECF4] border-[0.5px] rounded-[8px] !h-[40px]"
                                    icon={SearchIcon}
                                    value={showSearchPatientName ? showSearchPatientName : ''}
                                    setShowSearch={setShowSearchPatientName}
                                    clearSearch={() => {
                                        setShowSearchPatientName('')
                                    }}
                                    iconStyle="w-[18px] h-[18px] bottom-[12px] right-[10px] border-none rounded-[0px]"
                                />

                                <TextIconInput
                                    divStyle=""
                                    // label={"Date of birth"}
                                    minLength={4}
                                    placeholder="Patient date of brith"
                                    maxLength={50}
                                    name="DOB"
                                    id="DOB"
                                    inputStyle=" !h-[40px]"
                                    value={searchedDate ? searchedDate : ''}
                                    onChange={(e: any) => {
                                        handleBirthDate(e.target.value);
                                    }}
                                    type={"date"}
                                />

                            </div>
                            <div className=" h-[60vh] overflow-y-auto scrollable-hidden">
                                <Table
                                    loading={loader}
                                    data={searchPatientList}
                                    tableScroll={"100%"}
                                    tableHeight={440}
                                    sort={true}
                                    Clickable={true}
                                    pageSecondTableIndentifyClass="patientUpdateScrollableDiv"
                                    rowClick={(row: any) => {
                                        setSelectedPatient(row)
                                    }}
                                    hasNextPage={page < totalPage}
                                    NextPageData={handleNextPage}
                                    columns={[
                                        "Patient",
                                        "DOB",
                                        "Gender"
                                    ]}
                                    sortTitleKeys={{
                                        Patient: "lastName",
                                        Gender: "gender"
                                    }}
                                    handleSortfunc={(key: any, value: any) => {
                                        handlePatientListData({ 'sort': key, 'sortDir': value })
                                    }}
                                    scopedSlots={{
                                        Patient: ({ row }: any) => (
                                            <td title={`${WordTitle(row?.lastName)},
                                            ${WordTitle(row?.firstName)}`}>
                                                <div className=" max-w-[500px]
                                                truncate cursor-pointer">
                                                    {WordTitle(row?.lastName)},
                                                    {WordTitle(row?.firstName)}
                                                </div>
                                            </td>
                                        ),
                                        "DOB": ({ row }: any) => (
                                            <td title={row?.birthDate || ""}>
                                                <div className=" max-w-[500px] truncate cursor-pointer">
                                                    {row?.birthDate}
                                                </div>
                                            </td>
                                        ),
                                        Gender: ({ row }: any) => (
                                            <td title={row?.gender || ""}>
                                                <div className=" max-w-[500px] truncate cursor-pointer">
                                                    {WordTitle(row?.gender)}
                                                </div>
                                            </td>
                                        ),
                                        "Location": ({ row }: any) => (
                                            <td title={row?.location || ""}>
                                                <div className=" max-w-[500px] truncate cursor-pointer">
                                                    {WordTitle(row?.location)}
                                                </div>
                                            </td>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ConfirmPopup showModal={showConfirmModel} icon>
                    <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
                        Update Patient Details?
                    </div>
                    <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
                        <div className="grid grid-cols-[30%_max-content] gap-y-10px  text-left">
                            <div className=" font-medium">Patient :</div>
                            <div className=" max-w-[200px] truncate">
                                <div>
                                    {![null, "", undefined].includes(formik.values.patient_last_name) && ![null, "", undefined].includes(formik.values.patient_first_name)
                                        ? `${WordTitle(formik.values.patient_last_name || '')}, ${WordTitle(formik.values.patient_first_name || '')}`
                                        : (WordTitle(formik.values.patient_last_name || '') || WordTitle(formik.values.patient_first_name || ''))}
                                </div>
                            </div>
                            <div className=" font-medium">Birthday :</div>
                            <div className=" max-w-[200px] truncate"> {formik?.values?.DOB ? ConvertOutputDate(formik.values.DOB, "MM/DD/YYYY") : ''}</div>
                            <div className=" font-medium">Gender :</div>
                            <div className=" max-w-[200px] truncate"> {WordTitle(formik?.values?.gender ? formik.values.gender : '')}</div>
                            <div className=" font-medium">Location :</div>
                            <div className=" max-w-[200px] truncate"> {WordTitle(formik?.values?.location ? formik.values.location : '')}</div>
                            <div className=" font-medium">Date of Service :</div>
                            <div className=" max-w-[200px] truncate"> {formik?.values?.encounter_date ? ConvertOutputDate(formik.values.encounter_date, "MM/DD/YYYY") : ''}</div>
                        </div>
                        <div className="mt-2">
                            Are you sure you want to continue?
                        </div>
                    </div>
                    <div className="flex justify-center gap-[16px] items-center w-full">
                        <CustomButton
                            buttonName="Cancel"
                            primary={false}
                            buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px] hover:bg-gray-200  "
                            disable={buttonLoader}
                            onClick={() => {
                                setShowConfirmModel(false);
                            }}
                        />
                        <CustomButton
                            buttonName="Yes"
                            primary={true}
                            buttonStyle="w-full text-white  hover:bg-[#166B5E] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
                            loader={buttonLoader}
                            disable={buttonLoader}
                            loaderStyle="w-full bg-[#F5F5F5]/80  py-[13px] "
                            onClick={() => {
                                formik?.submitForm()
                                setShowConfirmModel(false)
                            }}
                        />
                    </div>
                </ConfirmPopup>
            </div>

        </SidePopup>

    );
};
